import alertIcon from "../../../assets/images/alert.svg";
import * as Icon from "react-bootstrap-icons";
export const GasLeakTitle = () => {
  return (
    <>
      <div className="modal-header__icon-wrapper">
        <img className="modal-header-icon" alt="alert" src={alertIcon} /> Gas
        Leak
      </div>
    </>
  );
};

export const GasLeakContent = () => {
  return (
    <>
      <p className="text-center justify-content-center">
        If you smell gas or suspect a leak, immediately call Atlanta Gas Light:
      </p>
      <div className="gas-leak-body">
        <div className="gas-leak-call">
          <p className="font-weight-bold">Inside Metro Atlanta</p>
          <div className="gas-leak-call-number">
            <Icon.Telephone className="gas-leak-call-icon" />{" "}
            <p className="gas-leak-call-text">(770) 907-4231</p>
          </div>
        </div>
        <div className="gas-leak-call">
          <p className="font-weight-bold">Outside Metro Atlanta</p>
          <div className="gas-leak-call-number">
            <Icon.Telephone className="gas-leak-call-icon" />{" "}
            <p className="gas-leak-call-text">(877) 427-4321</p>
          </div>
        </div>
      </div>
    </>
  );
};
